export default "__VITE_ASSET__ongwt0H7__"